import * as Sentry from '@sentry/browser';


/*Sentry.init({
    dsn: 'https://05ad3fe044a6493fbda3334d5a945b85@o215445.ingest.sentry.io/5503847',
    tracesSampleRate: 1.0,
    debug: true
});*/



export class Flocktory {

    constructor() {
        this.init();
    }

    init() {
        window.flocktory = window.flocktory || [];
        return window.flocktory;
    }

    push(paramKey = '', valueObject = {}, params = {}) {
        window.flocktory.push([paramKey, valueObject]);

        //console.log('Flocktory:' + paramKey);
        //console.log(valueObject);
        /*Sentry.captureEvent({
            message: 'FLOCKTORY_PUSH_' + paramKey,
            environment: NODE_ENV,
            level: Sentry.Severity.Debug,
            tags: {
                'SERVICES_INTEGRATION':'FLOCKTORY'
            },
            user: {
                valueObject: valueObject,
                dataParams: params,
                time: new Date().toTimeString()
            }
        });*/
    }

    postcheckout(order, basket, user) {

        let valueObject = {
            user: user,
            order: {
                id: order.id,
                price: order.price,
                items: [this.basketItems(basket)]
            }
        };

        this.push('postcheckout', valueObject, {order, basket, user});
    }

    basketItems(basket) {
        const items = [];
        basket.forEach((basketItem) => {
            items.push({
                id: basketItem.id,
                title: basketItem.name,
                price: basketItem.price,
                count: basketItem.quantity,
                category: basketItem.category,
                vendor: basketItem.vendor,
            });
        });
        return items;
    }

    addToCart(product) {
        this.push('addToCart', {item: {
            id: product.id,
            title: product.name,
            price: product.price,
            count: product.quantity,
            category: product.category,
            vendor: product.brand,
        }}, product);
    }

    removeFromCart(product) {
        this.push('removeFromCart', {item: {
            id: product.id,
            title: product.name,
            price: product.price,
            count: product.quantity,
            category: product.category,
            vendor: product.brand,
        }}, product);
    }

    updateCart(basketItems)
    {
        this.push('updateCart', {
            cart: {
                items: this.basketItems(basketItems)
            }
        }, basketItems);
    }
}



// WEBPACK FOOTER //
// ./modules/tracker/flocktory.js